import validator from 'validator';

export const validate_fields = (email, t) => {
    if (validator.isEmpty(email)) {
        return t('forgotPassword.email_empty');
    } else {
        if (!validator.isEmail(email)) {
        return t('forgotPassword.email_invalid');
        }
    }
    return ''
}

